import {
  Box,
  Checkbox,
  Divider,
  LoadingIndicator,
  TextButton,
  Typography,
} from '@wishket/design-system';
import { Fragment } from 'react';
import { twMerge } from 'tailwind-merge';

interface CollectionCheckBoxListProps {
  data: { label: string; value: number; isScrapped: boolean }[];
  onCollectionClick: (value: number) => void;
  isLoading: boolean;
  className?: string;
}

export const CollectionCheckBoxList = ({
  data,
  className,
  isLoading,
  onCollectionClick,
}: CollectionCheckBoxListProps) => {
  if (isLoading)
    return (
      <Box className={twMerge('relative h-12', className)}>
        <LoadingIndicator />
      </Box>
    );

  return (
    <>
      {data.map((item) => (
        <Fragment key={item.value}>
          <Box
            className="flex cursor-pointer items-center gap-3 py-4 desktop:gap-2 desktop:p-0"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onCollectionClick(item.value);
            }}
          >
            <Checkbox key={item.value} checked={item.isScrapped} />
            <Typography variant="body1" className="truncate">
              {item.label}
            </Typography>
          </Box>
          <Divider className="desktop:hidden" />
        </Fragment>
      ))}
    </>
  );
};

interface CreateCollectionButtonProps {
  onClick?: () => void;
  className?: string;
}

export const CreateCollectionButton = ({
  onClick,
  className,
}: CreateCollectionButtonProps) => {
  return (
    <Box
      className={twMerge(
        'flex cursor-pointer items-center gap-1 py-4',
        className
      )}
      onClick={onClick}
    >
      <TextButton text="컬렉션 만들기" leadingIcon="medium_plus" />
    </Box>
  );
};
